import { observable, runInAction } from "mobx";
import { api } from "../../api";
import {
  IEmpresa,
  ILogSefip,
  IMunicipio,
  IPis,
  ISefip,
  ISefipTransmissao,
  ISefipTransmissaoRecalc,
} from "../../model";
import { toast } from "react-toastify";

export class _TransmissaoStore {
  obs = observable({
    programarSolicitacoes: false as boolean,
    programarRecalculo: false as boolean,
    programarSefip: false as boolean,
    programarWebSefip: false as boolean,
    status_200: false as boolean,
    itensMunicipio: [] as IMunicipio[],
    viewDetalhes: false as boolean,
    SefipReq: [] as ILogSefip[],
    RecalculoPis: [] as IPis[],
    loading: false as boolean,
    viewArquivos: false as boolean,
    loadingArquivo: false as boolean,
    loadingArquivoAll: false as boolean,
    loadingViewArquivo: false as boolean,
    status_text: "" as string,
    loadingDetalhes: false as boolean,
    currentPage: 1 as number,
    transmissao_length: 1 as number,
    base64: "" as string,
  })


  constructor() {
  }

  async sendInitial(data: ISefip): Promise<void> {
    this.obs.programarSefip = false

    try {
      await api.post("/api/folha-sefip-transmissao", data);
      this.obs.status_200 = true;
    } catch (ex) {
      toast.error('Erro ao processar Folha Sefip Transmissão, tente novamente mais tarde.', {});
      this.obs.status_200 = false;
    }
  }

  async getMunicipio(): Promise<void> {
    try {
      let resp = await api.get("/api/municipios-sefip-transmissao");

      if (resp.data.length > 0) {
        this.obs.itensMunicipio = resp.data;
      }
    } catch (ex) {
      toast.error('Erro ao carregar Municipios, tente novamente mais tarde.', {});
    }
  }

  doSaveFile = async (sefip: ISefipTransmissaoRecalc) => {
    this.obs.programarRecalculo = false;

    try {
      this.obs.status_200 = false;

      let list_tmp = [];

      for (let i: number = 0; i < sefip.pis.length; i++) {
        list_tmp.push(sefip.pis[i].pis);
      }

      var data = new FormData();

      data.append("file", sefip.arquivo[0]);
      data.append(
        "competencia_atraso",
        `${sefip.competencia_atraso.getDate()}/${sefip.competencia_atraso.getMonth() + 1
        }/${sefip.competencia_atraso.getFullYear()}`,
      );
      data.append("competencia", sefip.competencia);
      data.append("pis", list_tmp.join());
      data.append("empresa", sefip.empresa_recalc);
      data.append("cpf", sefip.cpf_recalc.replace(/\./g, "").replace("-", ""));
      data.append("nome", sefip.nome_recalc);
      data.append("municipio", sefip.municipio_recalc);

      let resp = await api.post('/api/folha-recalculo', data)

      if (resp.data.ok) {

        this.obs.status_200 = true;
        toast.success('Solicitação enviada', {});

      } else {

        toast.error(resp.data.error, {});

      }

    } catch (ex) {
      toast.error('Erro ao processar Transmissão Recalculo, tente novamente mais tarde.', {});
    }
  };

  doSaveFileSEFIP = async (sefip: ISefipTransmissao) => {
    this.obs.programarSolicitacoes = false

    try {
      this.obs.status_200 = false;

      var data = new FormData();
      data.append("empresa", sefip.empresa_recolhimento);
      data.append("tipo_folha", sefip.tipo_folha);
      data.append("competencia", sefip.competencia);
      data.append("cod_folha", sefip.cod_folha);
      data.append("cpf", sefip.cpf);
      data.append("fap", sefip.fap);
      data.append("fgts", sefip.fgts);
      data.append("file", sefip.arquivo);
      data.append("municipio", sefip.municipio_recolhimento);
      data.append("nome", sefip.nome);

      let resp = await api.post('/api/sefip-transmissao', data)

      if (resp.status == 200) {
        this.obs.status_200 = true;

      } else if (resp.status == 406) {
        this.obs.status_text = "A empresa selecionada não consta no arquivo SEFIP RE enviado";

      } else if (resp.status == 500) {
        this.obs.status_text = "Erro ao enviar a solicitação";
      }

    } catch (err) {
      toast.error('Erro ao processar Sefip Transmissão, tente novamente mais tarde.', {});
      this.obs.status_text = err;
    }
  };

  async buscaPagedSefip(cnpj_cpf: string, tipo: string, page: number, date1: string, date2: string,) {
    try {
      this.obs.loading = true;

      let req;

      if (cnpj_cpf.replace(/\./g, "").replace("-", "").length == 11) {
        req = { cnpj: "", cpf: cnpj_cpf, page: page, limit: 50, data1: date1, data2: date2 };
      } else {
        req = { cnpj: cnpj_cpf, cpf: "", page: page, limit: 50, data1: date1, data2: date2 };
      }

      let resp;

      if (tipo == "recalculo") {
        resp = await api.post(`/api/consulta-status-lote-folha-recalculo`, req);
      } else if (tipo == "transmissao") {
        resp = await api.post(`/api/consulta-status-lote-sefip-transmissao`, req);
      } else if (tipo == "web") {
        resp = await api.post(`/api/consulta-status-lote-folha-web-sefip-transmissao`, req);
      } else {
        resp = await api.post(`/api/consulta-status-lote-folha-sefip-transmissao`, req);
      }

      runInAction(() => {
        if (resp.data.items.length) {
          this.obs.transmissao_length = resp.data.count;
          this.obs.SefipReq = resp.data.items;
        } else {
          this.obs.transmissao_length = 0
          this.obs.currentPage = 1
          this.obs.SefipReq = [];
        }
        this.obs.loading = false;
      });
    } catch (ex) {
      this.obs.loading = false;
      toast.error('Erro ao buscar Sefip, tente novamente mais tarde.', {});
    }
  }

  async downloadArquivosAll(uuid: string, cnpj: string, cpf: string) {
    try {
      this.obs.loadingArquivoAll = true;

      let req = { uuid: uuid };

      let resp = await api.post(`/api/download-todas-transmissoes`, req);

      const linkSource = `data:application/zip;base64,${resp.data}`;
      const downloadLink = document.createElement("a");
      let fileName;

      if (cnpj != "") {
        fileName = "arquivos_transmissao_" + cnpj + ".zip";
      } else {
        fileName = "arquivos_transmissao_" + cpf + ".zip";
      }

      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();

      this.obs.loadingArquivoAll = false;

    } catch (ex) {
      this.obs.loadingArquivoAll = false;
      toast.error('Erro ao realizar download Transmissões, tente novamente mais tarde.', {});
    }
  }

  async downloadArquivo(uuid: string, nome: string, id: number) {
    try {
      this.obs.loadingArquivo = true;
      let aux = nome.split(".");
      let l = aux.length;
      let format = l - 1;
      let req = { uuid: uuid, file_id: id };

      let resp = await api.post(`/api/download-transmissao`, req);

      const linkSource = `data:application/${format};base64,${resp.data}`;
      const downloadLink = document.createElement("a");
      const fileName = nome;

      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();

      this.obs.loadingArquivo = false;

    } catch (ex) {
      this.obs.loadingArquivo = false;
      toast.error('Erro ao realizar download Transmissão, tente novamente mais tarde.', {});
    }
  }

  async consultaArquivo(uuid: string) {
    try {
      this.obs.loadingDetalhes = true

      let req = { uuid: uuid };

      let resp = await api.post(`/api/consulta-arquivo-tarefa`, req);

      this.obs.loadingDetalhes = false

      return resp.data;

    } catch (ex) {
      this.obs.loadingDetalhes = false
      toast.error('Erro ao consultar Arquivo Tarefa Transmissão, tente novamente mais tarde.', {});
    }
  }

  async consultaErro(uuid: string) {
    try {
      this.obs.loadingDetalhes = true

      let req = { uuid: uuid };

      let resp = await api.post(`/api/consulta-erro-tarefa`, req);

      if (resp.data.length) {
        this.obs.loadingDetalhes = false
        return resp.data;

      } else {
        this.obs.loadingDetalhes = false
        return [" "]
      }
    } catch (ex) {
      this.obs.loadingDetalhes = false
      toast.error('Erro ao consultar Erro Tarefa Transmissão, tente novamente mais tarde.', {});
    }

  }

  async sendInitialFolhaWeb(data: ISefip): Promise<void> {
    this.obs.programarWebSefip = false

    try {
      await api.post("/api/folha-web-sefip-transmissao", data);
      this.obs.status_200 = true;
    } catch (ex) {
      toast.error('Erro ao processar Folha Web Sefip Transmissão, tente novamente mais tarde.', {});
      this.obs.status_200 = false;
    }
  }

  async handleBuscaEstado(estado: string) {

    try {
      const response = await fetch(
        `https://servicodados.ibge.gov.br/api/v1/localidades/estados/${estado}/distritos`
      );
      if (!response.ok) {
        toast.error('Erro ao buscar Municípios', {});
      }
      const data = await response.json();
      let itensMunicipio = []
      data.map(x => {
        if (itensMunicipio.findIndex(item => item.id === x.municipio.id) === -1) {
          itensMunicipio.push({ id: x.municipio.id, nome: x.municipio.nome, estado: estado })
        }
      })
      return itensMunicipio
    } catch (error) {
      toast.error(error, {});
      return []
    }
  }

}

export const TransmissaoStore = new _TransmissaoStore();